<template>
  <div :class="getPadding()">
    <v-card :class="$vuetify.display.smAndDown ? 'msg mobile my-4' : 'msg my-4'">
      <v-card-text>
        <div v-if="summaryFormatted !== ''">
          <p class="text-overline">{{ getTime(timestamp) }}</p>
          <pre ref="pre"><code class="chat-text language-markdown" v-html="summaryFormatted"></code></pre>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="msg clickable" @click="onFullAnalysisClick">
      <v-btn
        class="expand-btn" icon="mdi-chevron-down" variant="text" size="x-large"
      ></v-btn>
      <v-card-title class="clickable d-block mr-8 mb-n1">
        Full Analysis
      </v-card-title>
    </v-card>
  </div>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { marked } from 'marked'
import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'
import Code from './Code.vue'

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    }
  },
  props: {
    symbol: String,
    summary: String,
    timestamp: Number,
    cta: Function
  },
  components: {
    Code
  }
})
export default class AnalysisBrief extends Vue {
  public $vuetify: any
  public breakpoint!: string
  public symbol!: string
  public summary!: string
  public timestamp!: number
  public cta!: Function
  public summaryFormatted: string = ''

  public getTime(timestamp: number) {
    return new Date(timestamp).toLocaleTimeString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    })
  }

  async mounted() {
    await this.formatSummary()
  }

  async formatSummary() {
    this.summaryFormatted = await this.formatMarkdown(this.summary)
  }

  async formatMarkdown(text: string): Promise<string> {
    return marked.parse(text)
  }

  public getPadding() {
    switch (this.breakpoint) {
      case 'xs':
        return 'mx-0'
      case 'sm':
        return 'mx-0'
      case 'md':
        return 'mx-4'
      case 'lg':
        return 'mx-4'
      case 'xl':
        return 'mx-4'
      default:
        return 'mx-4'
    }
  }

  public onFullAnalysisClick() {
    if (this.cta == null) {
      return
    } else {
      this.cta(this.symbol)
    }
  }
}
</script>
<style scoped lang="scss">
  .clickable {
    cursor: pointer;
  }
  
  .expand-btn {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px;
  }

  .msg {
    border: 1px solid rgb(133, 133, 133);
    border-radius: 8px;
    padding: 20px;

    &.mobile {
      padding: 10px;
    }
  }

  code[class*="language-"] > ul,
  code[class*="language-"] > ol {
    padding-left: 40px;
  }

  code[class*="language-"] > hr:first-child {
    display: none !important;
    opacity: 0;
  }

  pre[class*="language-" ],
  code[class*="language-"] {
    background: #02131f;
    box-sizing: border-box;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 18px;
    overflow: auto;
    white-space: normal;
    word-break: break-word;

    ol {
      margin-left: 40px;
    }
    ul {
      margin-left: 40px;
    }
    dl {
      margin-left: 40px;
    }

    &:deep(ul, ol, dl) {
      padding-left: 40px;
      // padding-left: 1rem;
      list-style-position: outside;
    }
  }
</style>